import $ from 'jquery';
import { getParams } from '../util/urlParam';
import { exhibitioninfo, langList  } from '../variables';
import { getUserJqXHR,getMypageShowJqXHR,getConsiderationsJqXHR,getfavoritesJqXHR,
  getCardExchangesJqXHR,getMgJqXHR,postConsiderJqXHR,deleteConsiderJqXHR,
  postLikeJqXHR,deleteLikeJqXHR} from '../api';
import { User, MypageShows, Meeting, Company, Product, CardExchange} from '../model/index';
import translate, { Lang, t } from '../util/translate';
import CompanyCard from '../components/CompanyCard';
import { ProductCard } from '../components/ProductCard';
import { CardExchangeCard } from '../components/CardExchangeCard';
import MeetingComponent from '../components/MeetingComponent';
import { login, logout } from '../util/auth';
import Alert from '../util/alert';
import { getCookie } from '../util/cookie';

$(() => {
  // ローカルストレージ非対応環境
  if (!window.localStorage) {
    alert("お使いのブラウザは対応してません。Chromeなどの他ブラウザをご利用ください。");
  }

  // Token 取得
  const token = getCookie('loginToken') as string;
  if( !token ){
    // Tokenがない
    window.location.href = process.env.GIFT_NET_URL + 'registration/login.html';
  }
  
  // クエリ取得
  const params = getParams(exhibitioninfo);

  // 言語設定 クエリ優先 -> localStorage
  let lang = 'ja' as keyof Lang
  if (langList.indexOf(String(params.lang)) !== -1) {
    lang = params.lang as keyof Lang;
    localStorage.setItem('lang', lang);
  }else{
    lang = (localStorage.getItem('lang') ?? 'ja') as keyof Lang;
  }
  
  $('#loading').show(); // ロードを開始
  translate(); // 翻訳
  
  // ログイン・ログアウトイベント
  $('.login').on('click', login);
  $('.logout').on('click', logout);
  $('#logout').on('click', logout);

  // メニューボタンのリンク先設定
  let link  = document.getElementById("link_howto") as HTMLAnchorElement;
  link.href = process.env.GIFT_NET_URL + "registration/mypage/howto.html" as string;
  link  = document.getElementById("link_faq") as HTMLAnchorElement;
  link.href = "https://www.giftnet.jp/" as string;
  link  = document.getElementById("link_search") as HTMLAnchorElement;
  link.href = "mailto:giftnet@giftshow.co.jp" as string;

  // ユーザー情報 取得
  const userJqXHR = getUserJqXHR();
  userJqXHR
  .done((userinfo) => {
    const user : User = userinfo.data;
    //vip
    let obj = document.getElementById("vip");
    if ( obj != null ){
      obj.style.display = (user.vipFlag === "1" ? "inline-block" : "none" )
    }

    // id
    var id = document.getElementsByClassName('js-id')[0];
    id.innerHTML = user.userCode;

    // 名前
    var name = document.getElementsByClassName('js-name')[0];
    name.innerHTML = user.familyName + ' ' + user.givenName + '様';

    // 会社名
    var company = document.getElementsByClassName('js-company')[0];
    company.innerHTML = user.companyName;

    // 業種
    var industry = document.getElementsByClassName('js-industry')[0];
    industry.innerHTML = user.industryValue;

    // 居住地域対応
    if(  user.areaIndex == 1 ){
      // 日本
      var area = document.getElementsByClassName('js-area')[0];
      area.innerHTML = t.prefectures[lang];
      // 都道府県
      var prefecture = document.getElementsByClassName('js-prefecture')[0];
      prefecture.innerHTML = user.prefecture;
    }else{
      // 日本以外
      var area = document.getElementsByClassName('js-area')[0];
      area.innerHTML = t.country[lang];;
      // 国
      var prefecture = document.getElementsByClassName('js-prefecture')[0];
      prefecture.innerHTML = user.country;
    }
    //QR
    if(( user.applyList[0] != 'registOnly' ) ){
      let text = user.applyList.join('-') + '\r\n' + user.userCode + '\r\n' + user.industryValueIndex + '\r\n' + user.familyName + ' ' + user.givenName + '\r\n' + user.companyName + '\r\n' + user.prefectureIndex + '\r\n' + user.vipFlag + '\r\n' + user.occupationIndex;
      // let text = unescape(encodeURIComponent(user.applyList.join('-') + '\r\n' + user.userCode + '\r\n' + user.industryValueIndex + '\r\n' + user.familyName + ' ' + user.givenName + '\r\n' + user.companyName + '\r\n' + user.prefectureIndex + '\r\n' + user.vipFlag + '\r\n' + user.occupationIndex));
      const QRCode = require('qrcode');
      QRCode.toDataURL(text, function (err:any, url:any) {
        $('#no-qr').hide();
        $('#js-qr').html(`<img src="${url}">`);
      });
    }
    // APIデータ取得
    const showsJqXHR = getMypageShowJqXHR();
    const considerationsJqXHR = getConsiderationsJqXHR();
    const favoritesJqXHR = getfavoritesJqXHR();
    const cardExchangesJqXHR = getCardExchangesJqXHR();
    const mgJqXHR = getMgJqXHR();

    $.when( showsJqXHR, considerationsJqXHR, favoritesJqXHR,  cardExchangesJqXHR,mgJqXHR)
      .done(( jqShows, jqConsiderations, jqfavoritesJqXHR, jqCardExchanges, jqMg) => {
        const shows: MypageShows[] = jqShows[0];
        const total_co: number = jqConsiderations[0].total;
        const companies: Company[] = jqConsiderations[0].data;
        const total_fa: number = jqfavoritesJqXHR[0].total;
        const products: Product[] = jqfavoritesJqXHR[0].data;
        const total_cd: number = jqCardExchanges[0].total;
        const cardExchanges: CardExchange[] = jqCardExchanges[0].cards;

        const meetings: Meeting[] = jqMg[0];

        // 展示会表示
        let alreadyName :string = "";
        shows.forEach( (value: MypageShows) => {
          let regist_start = new Date(value.regist_start);
          let regist_end = new Date(value.regist_end);
          let today = new Date();
          let date_sddress = value.date_name ? value.date_name : "";;
          if( value.already_registered ){
            if ((value.registable_status == 'yes')
              && (regist_start <= today)
              && (regist_end >= today)) {
                alreadyName += `
                <div class="already_exhibition mb-2">
                  <div class="box1">
                    <span class="show_name">・${value.tenji_name} ${date_sddress}</span>
                  </div>
                </div>
            `}
          }
        });
        if( alreadyName !== "" ){
            // 来場予定
          $('#no-planed').hide();
          $('#js-visitList').html(alreadyName);
        }

        // 検討リスト一覧 表示
        $('#search-result-campany-number').html(`${total_co}`);
        let companyList = '';
        if (companies && companies.length > 0) {
          let arrayLength =companies.length;
          let cnt = 0;
          let maxshow = 2;
          for(  ; cnt < arrayLength ; cnt ++ ){
            if( cnt >= maxshow )  break;
            companyList += CompanyCard(companies[cnt]);
          }
          let resultbtn = document.getElementById("campany_linkbtn");
          if ( resultbtn != null ){
            if( arrayLength <= maxshow ) resultbtn.style.display ="none";
          }
          $('#search-result-campany').html(companyList);
        }

        // いいね一覧 表示
        $('#search-result-product-number').html(`${total_fa}`);
        let productList = '';
        if (products && products.length > 0) {
          let arrayLength =products.length;
          let cnt = 0;
          let maxshow = 4;
          for(  ; cnt < arrayLength ; cnt ++ ){
            if( cnt >= maxshow )  break;
            productList += ProductCard(products[cnt]);
          }
          let resultbtn = document.getElementById("product_linkbtn");
          if ( resultbtn != null ){
            if( arrayLength <= maxshow ) resultbtn.style.display ="none";
          }
          $('#search-result-product').html(productList);
        }

        // 名刺交換履歴 表示
        $('#search-result-namecard-number').html(`${total_cd}`);
        let namecardList = '';
        if (cardExchanges && cardExchanges.length > 0) {
          let arrayLength =cardExchanges.length;
          let cnt = 0;
          let maxshow = 3;
          for(  ; cnt < arrayLength ; cnt ++ ){
            if( cnt >= maxshow )  break;
            namecardList += CardExchangeCard(cardExchanges[cnt]);
          }
          let resultbtn = document.getElementById("namecard_linkbtn");
          if ( resultbtn != null ){
            if( arrayLength <= maxshow ) resultbtn.style.display ="none";
          }

          $('#search-result-namecard').html(namecardList);
        }


        // 産地商談会
        let meetingList: string = '';
        meetings.forEach((item) => {
          meetingList += MeetingComponent({
            className: 'meeting-label',
            name: item.name,
            url: item.url,
            show_img: item.show_img,
            name_tag: item.name_tag,
          });
        });
        $('#meeting-list').html(meetingList);
      })
      .fail(() => {
        alert('読込に失敗しました。再度ページを読み込んでください。');
      })
      .always(() => {
      });
  })
  .fail(() => {
    alert('データの取得に失敗しました。リロード又は再度ログインを行ってください。');
    // // Tokenはあるが不正
    // removeCookie('loginToken');
    // window.location.href = process.env.GIFT_NET_URL + 'registration/login.html';
  })
  .always(() => {
  });


  // giftnet-portalからコピー
  // 検討リストへの追加 削除機能
  $(document).on('click', '.campany-content', function () {
    console.log('click', 'click');
    // アイコン 要素
    const considerAdd = $(this).find('.company-star');
    const considerDelete = $(this).find('.company-star-active');
    console.log(considerAdd, 'add');
    console.log(considerDelete, 'delete');
    // 企業ID
    const shop_id: string = $(this).data('shop_id');
    console.log(shop_id, 'shop_id');

    // お気に入り登録しているかどうか
    const favorite: boolean =
      $(this)[0].getAttribute('data-favorite') === 'true' && true;
    console.log(favorite, 'favorite');

    // お気に入りの登録 or 解除
    if (!favorite) {
      const favoJqXHR = postConsiderJqXHR(shop_id);
      considerAdd.hide();
      considerDelete.show();
      console.log('deleteShow');
      $(this).addClass('company-consider-active');
      favoJqXHR
        .done(() => {
          $(this)[0].setAttribute('data-favorite', 'true');
        })
        .fail(() => {
          considerAdd.show();
          considerDelete.hide();
          Alert({
            icon: 'error',
            titleKey: 'errNeedLogin',
            trnKey: 'errRegisterFavorite',
            confirmButtonKey: 'login',
            onClick: () => login(),
          });
        });
    } else {
      const favoJqXHR = deleteConsiderJqXHR(shop_id);
      considerDelete.hide();
      considerAdd.show();
      console.log('addShow');
      $(this).removeClass('company-consider-active');
      favoJqXHR
        .done(() => {
          $(this)[0].setAttribute('data-favorite', 'false');
        })
        .fail(() => {
          considerAdd.hide();
          considerDelete.show();
          Alert({
            icon: 'error',
            trnKey: 'errRemoveFavorite',
            confirmButtonKey: 'login',
            onClick: () => login(),
          });
        });
    }
  });

  // いいね機能
  $(document).on('click', '.product-result__likes', function () {
    // 画像要素
    const addLikeImg = $(this).find('.like');
    console.log('addLikeImg: ', addLikeImg);
    const deleteLikeImg = $(this).find('.like-delete');
    // ショップid
    const shop_id: string = $(this).data('shop_id');
    // 商品id
    const product_id: string = $(this).data('product_id');
    // いいね登録しているかどうか
    const islike: boolean = $(this).data('islike');
    // いいねの切り替え処理
    if (!islike) {
      const likeJqXHR = postLikeJqXHR(shop_id, product_id);
      addLikeImg.hide();
      deleteLikeImg.show();
      $(this).addClass('favorite-active');

      likeJqXHR
        .done(() => {
          $(this).data('islike', true);
        })
        .fail(() => {
          addLikeImg.show();
          deleteLikeImg.hide();
          $(this).removeClass('favorite-active');
          Alert({
            icon: 'error',
            titleKey: 'errNeedLogin',
            trnKey: 'errRegisterFavorite',
            confirmButtonKey: 'login',
            onClick: () => login(),
          });
        });
    } else {
      const likeJqXHR = deleteLikeJqXHR(shop_id, product_id);

      addLikeImg.show();
      deleteLikeImg.hide();
      $(this).removeClass('favorite-active');

      likeJqXHR
        .done(() => {
          $(this).data('islike', false);
        })
        .fail(() => {
          addLikeImg.hide();
          deleteLikeImg.show();
          $(this).addClass('favorite-active');
          Alert({
            icon: 'error',
            trnKey: 'errRemoveFavorite',
            confirmButtonKey: 'login',
            onClick: () => login(),
          });
        });
    }
  });


  // フッター問い合わせ
  let contactlist: string = 
  `
  <dd><span>`+ t.footer_tigs[lang] + t.footertel_tigs[lang] +`</span> <a href="mailto:`+ t.footermail_tigs[lang] +`">`+ t.footermail_tigs[lang] +`</a>)</dd>
  <dd><span>`+ t.footer_ld[lang] + t.footertel_ld[lang] +`</span> <a href="mailto:`+ t.footermail_ld[lang] +`">`+ t.footermail_ld[lang] +`</a>)</dd>
  <dd><span>`+ t.footer_landd[lang] + t.footertel_landd[lang] +`</span> <a href="mailto:`+ t.footermail_landd[lang] +`">`+ t.footermail_landd[lang] +`</a>)</dd>
  <dd><span>`+ t.footer_gds[lang] + t.footertel_gds[lang] +`</span> <a href="mailto:`+ t.footermail_gds[lang] +`">`+ t.footermail_gds[lang] +`</a>)</dd>
  <dd><span>`+ t.footer_pi[lang] + t.footertel_pi[lang] +`</span> <a href="mailto:`+ t.footermail_pi[lang] +`">`+ t.footermail_pi[lang] +`</a>)</dd>
  <dd><span>`+ t.footer_osaka[lang] + t.footertel_osaka[lang] +`</span> <a href="mailto:`+ t.footermail_osaka[lang] +`">`+ t.footermail_osaka[lang] +`</a>)</dd>
  <dd><span>`+ t.footer_fukuoka[lang] + t.footertel_fukuoka[lang] +`</span> <a href="mailto:`+ t.footermail_fukuoka[lang] +`">`+ t.footermail_fukuoka[lang] +`</a>)</dd>
  `;
  $('#box_officework').html(contactlist);

  translate(); // 翻訳
  $('#loading').hide(); // ロードを解除

});


$(function () {
  // 追加展示会リンクをクリック時
  $(document).on('click', '.ExhibitionLink', function(){ 
    localStorage.setItem('exhibition', $(this).data('value'));
    location.href = './set.html';
  });

});

// 戻ってきたら強制リロード
window.onpageshow = function(event:any) {
	if (event.persisted) {
		 window.location.reload();
	}
};